import React from 'react';
import Modal from 'react-modal';
import styles from './styles.module.scss';
import sharedStyles from '../../styles.module.scss';
import { Button } from '../../../Input/Button/Button';

export interface ConfirmDeleteUserProps {
  isOpen: boolean;
  onConfirm: () => void;
  onClose: () => void;
  user: {
    firstName?: string;
    lastName?: string;
    email?: string;
  };
}
const ConfirmDeleteUser: React.FC<ConfirmDeleteUserProps> = ({
  isOpen,
  onConfirm,
  onClose,
  user,
}) => {
  Modal.setAppElement('#root');
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Are you sure you want to delete this user?"
      className={styles.deleteModal}
    >
      <div className={styles.modalTitle}>
        Are you sure you want to delete this user?
      </div>
      <div className={styles.userDetails}>
        <b>First Name: </b>
        <span>{user.firstName}</span>
        <b>Last Name: </b>
        <span>{user.lastName}</span>
        <b>Email: </b>
        <span>{user.email}</span>
      </div>

      <div className={sharedStyles.pageNav}>
        <Button
          className={sharedStyles.pageNavButton}
          label="Cancel"
          onClick={onClose}
        />
        <div className="spacer" />
        <Button
          className={sharedStyles.pageNavButton}
          label="Delete User"
          variant="danger"
          onClick={() => {
            onConfirm();
            onClose();
          }}
        />
      </div>
    </Modal>
  );
};

export default ConfirmDeleteUser;
